import React from "react";
import { FaClock, FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { IoIosMailUnread } from "react-icons/io";
import { TbMessages } from "react-icons/tb";
import { FaLocationDot } from "react-icons/fa6";

const Footer = () => {
	const redes = [
		{
			name: "",
			icon: FaWhatsapp,
			url: "https://api.whatsapp.com/send/?phone=522221005624&text&type=phone_number&app_absent=0",
		},
		{
			name: "",
			icon: FaInstagram,
			url: "https://www.instagram.com/alianza_genesis_/",
		},
		{ name: "", icon: IoIosMailUnread, url: "genesis.1902@outlook.com" },
		{
			name: "",
			icon: FaFacebook,
			url: "https://www.facebook.com/people/Alianza-Cooperativa-G%C3%A9nesis/100083354671999/",
		},
	];

	return (
		<footer className="h-fit w-full grid grid-cols-1 p-4 bg-orange-600/85 shadow text-white">
			<div className="grid grid-cols-3">
				<div className="grid place-items-center gap-2">
					<TbMessages size={44} />
					<h2> CONTACTO </h2>
					<p> Tel. 2221005624 </p>
					<p> Email. genesis.1902@outlook.com </p>
				</div>
				<div className="grid place-items-center gap-2">
					<FaLocationDot size={44} />
					<h2> DIRECCIÓN </h2>
					<p>
						{" "}
						Calle 7 Sur No.3702, Interior 6, Despacho D, Colonia Gabriel Pastor,
						Código Postal 72420 Puebla.{" "}
					</p>
				</div>
				<div className="grid place-items-center gap-2">
					<FaClock size={44} />
					<h2>HORARIO DE ATENCIÓN</h2>
					<p>Lun - Vie 10:00 am - 7:00 pm</p>
					<p>Sábado 10:00 am - 2:30 pm</p>
					<p>Domingo Cerrado</p>
				</div>
			</div>
			<div className="flex flex-row justify-center gap-8 py-8">
				{redes.map((red, index) => {
					const Icon = red.icon;
					return (
						<a
							key={index}
							href={red.url}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={red.name}
							className="text-white text-2xl hover:text-yellow-300 transition-colors"
						>
							<Icon />
						</a>
					);
				})}
			</div>
		</footer>
	);
};

export default Footer;
